import { render, staticRenderFns } from "./DashboardOverview.vue?vue&type=template&id=9fd5c036&"
import script from "./DashboardOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports